import { Injectable } from '@angular/core';

// Generates the link to a tenant's portal. The portal itself is a separate
// application (separate repo) — this service only mints the per-tenant URL that
// a manager can copy/share. It is intentionally self-contained so the same
// token logic can be copy-pasted into the portal app to resolve the token back
// to a tenant.
@Injectable({
  providedIn: 'root'
})
export class TenantPortalService {

  // Point this at the deployed origin of the tenant-portal app.
  readonly portalBaseUrl = 'https://portal.tidy.com';

  // Deterministic, opaque token derived from a stable identifier (the tenant's
  // email). Same tenant → same link every time, with no PII in the URL.
  portalToken(identifier: string): string {
    const key = (identifier || '').trim().toLowerCase();
    return this.hash(key, 5381) + this.hash(key, 52711, true);
  }

  portalLink(identifier: string): string {
    return `${this.portalBaseUrl}/t/${this.portalToken(identifier)}`;
  }

  private hash(key: string, seed: number, reverse = false): string {
    let hash = seed;
    if (reverse) {
      for (let i = key.length - 1; i >= 0; i--) {
        hash = ((hash << 5) + hash + key.charCodeAt(i)) >>> 0;
      }
    } else {
      for (let i = 0; i < key.length; i++) {
        hash = ((hash << 5) + hash + key.charCodeAt(i)) >>> 0;
      }
    }
    return hash.toString(16).padStart(8, '0');
  }
}
